import z from "zod";

export const yearlyQuerySchema = z.object({
	year: z.coerce.number(),
});

export type YearlyQuerySchema = z.infer<typeof yearlyQuerySchema>;
